import '../styles/Sidebar.scss';
import { useEffect, useState } from 'react';
import { useAlertsContext } from '../contexts/AlertsContext.js';

export default function Tab({ tab, mainExpand, panel, setPanel }) {
    const [expand, setExpand] = useState(false);

    const {
        alerts
    } = useAlertsContext();

    useEffect(() => {
        if(!mainExpand) setExpand(false);
    }, [mainExpand]);

    // Helper function to determine if a tab should be highlighted
    const isTabActive = () => {
        // Direct match (e.g., "Fires" panel with "Fires" tab)
        if (tab.name.includes(panel.name)) {
            return true;
        }
        
        // Check if current panel is a sub-panel of this tab
        const subPanelMappings = {
            'Fires': ['Fire PopUp', 'Historical Fire PopUp', 'Add Fire', 'Edit Fire'],
            'Predictions': ['Prediction PopUp'],
            'Monitoring Areas': ['Monitoring Areas - Create'],
            'RAWS': ['RAWS - Singular'],
            'Sensor Data': ['Sensor Data Popup']
        };
        
        const subPanels = subPanelMappings[tab.name] || [];
        return subPanels.some(subPanel => panel.name === subPanel);
    };

    const isActive = isTabActive();

    return (
        <div className='sidebar-tabs-tab' onClick={() => setPanel({name: tab.name, content: null})}>
            <div className={`sidebar-tabs-tab-header ${isActive ? 'active' : ''}`}>
                <div className='sidebar-tabs-tab-container'>
                   {(tab.name.includes('Alerts') && (alerts.filter((a) => a && a.incident_id).length > 0 || alerts.filter((a) => a && a.area_id).length > 0)) && 
                   <div className='sidebar-tabs-tab-container-count'>
                        <div className='sidebar-tabs-tab-container-count-text'>{alerts.filter((a) => a && (a.incident_id || a.area_id)).length}</div>
                    </div>}
                    <tab.icon 
                        size={24} 
                        className='sidebar-tabs-tab-header-icon' 
                    />
                </div>
                <div className='sidebar-tabs-tab-header-text'>{tab.name}</div>
            </div>
            {
                expand && <div className='sidebar-tabs-tab-expand'>
                    {
                        tab.tabs.map((tab, index) => {
                            return <div key={index} className='sidebar-tabs-tab-expand-tab'>{tab}</div>
                        })
                    }
                </div>
            }
        </div>
    );
}